<div class="flex flex-col gap-8">
  <div>
    <fun-icon [name]="icon" [style]="iconClass"></fun-icon>
  </div>
  <div [class]="textContentClass">
      <h5 [class]="textClass" [innerHTML]="title"></h5>
      <p [class]="contentClass">{{content}}</p>
  </div>
</div>